/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useMediaQuery, Grid, Box, useTheme, Typography, Button } from "@mui/material";
import CustomRightImage from "@components/CustomRightImagev2";
import CreditOfferCard from "@components/CreditOfferCard";
import { RootState } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import { ApiError } from "@interfaces/index";
import { setModalErrorVisible } from "@store/slices/appSlice";
import * as Sentry from "@sentry/react";
import { useLazyGetOffersQuery } from "@api/marketPlaceApis";
import { setSelectedOffer } from "@store/slices/marketPlaceSlice";
import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import { signOut } from "aws-amplify/auth";

const OfertaSeleccionadaCompany: React.FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const interfaceConfig = useInterfaceConfig();

  const company = useSelector((state: RootState) => state.register.company);
  const offer = useSelector((state: RootState) => state.marketPalce.offers);
  const application = useSelector((state: RootState) => state.register.application);

  const [getOffersMarket] = useLazyGetOffersQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const channel = new BroadcastChannel("session");

  const handleSelectedOffer = async () => {
    await signOut();
    sessionStorage.clear();
    channel.postMessage("logout");
    window.location.href = interfaceConfig.home_url;
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const responseOffers = await getOffersMarket({ id_sol: application.id }).unwrap();

        const selected: LoanApplicationOfferResponse[] = responseOffers.filter((of) => of?.accept);

        dispatch(setSelectedOffer(selected[0]));
      } catch (error) {
        const api_error = error as ApiError;
        Sentry.captureException(error, {
          extra: {
            component: "SolicitudCreditoPart1-initial_fetch",
          },
        });
        dispatch(setModalErrorVisible({ open: true, error: api_error }));
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={4}>
        <Typography
          sx={{ mb: 1 }}
          variant={isMobileOrTablet ? "h4" : "h3"}
          fontWeight={600}
          color={theme?.palette?.primary?.main}
          textAlign={"center"}
        >
          ¡Tenemos buenas noticias! <br />
          {company.legal_name}
        </Typography>

        <Box mr={3} ml={3}>
          <Typography
            sx={{ mb: 1 }}
            variant={"body1"}
            fontWeight={300}
            color={theme?.palette?.primary?.dark}
            textAlign={"center"}
          >
            Esta oferta se completará a través del flujo digital de{" "}
            <span style={{ fontWeight: 600 }}>{offer.financial_company.name}</span>, <br />
            operado en la plataforma de Lendia - PyMio.
            <br />
            <br />
            Al continuar,{" "}
            <span style={{ fontWeight: 600 }}>
              {" "}
              serás redirigido para finalizar tu proceso de forma rápida y segura{" "}
            </span>
            , con el mismo equipo y acompañamiento que te ha atendido hasta ahora.
          </Typography>
        </Box>

        <Box
          mt={6}
          sx={{
            backgroundColor: "#C2E5F3",
            borderRadius: 10,
            p: "10px 0", // paddingTop y paddingBottom juntos
            maxWidth: 500,
            margin: "0 auto", // centra horizontalmente
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CreditOfferCard key={offer.id} offer={offer} offers_length={0} showButton={false} />
        </Box>
        <Box display="flex" justifyContent="center" mt={isMobileOrTablet ? 2 : 4} mb={1}>
          <Button variant="default" onClick={handleSelectedOffer} sx={{ width: "130px" }} disabled={isLoading}>
            Continuar
          </Button>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default OfertaSeleccionadaCompany;
